export const getCookie = name => {
  const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`)
  const arr = document.cookie.match(reg)

  if (!arr || !unescape(arr[2])) return ''
  return unescape(arr[2])
}
